import { gql } from 'apollo-boost';

export const userDetails = gql`
  query ($id: ID) {
    allUsers(filters: {id: $id}) {
      edges {
          node {
              dbId
              title
              phone
              enabled
              email
              firstName
              lastName
          }
      }
    }
  }
`;
